import { ForecastBlueprintComponent } from './components/planner-dashboard/components/forecast-blueprint/forecast-blueprint.component';
import { DealListComponent } from './components/deal-list/deal-list.component';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { PlannerRoutingModule } from './planner-routing.module';
import { AppCommonModule } from './../common/common.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Service
import { ListActionsService } from './services/list-actions.service';
import { DataService } from './services/data.service';

//Plan list page componets
import { AdvertiserDashboardComponent } from './components/advertiser-dashboard/advertiser-dashboard.component';
import { PlannerListComponent } from './components/advertiser-dashboard/components/planner-list/planner-list.component';
import { MarketDashboardComponent } from './components/market-dashboard/market-dashboard.component';
import { AdvertiserListComponent } from './components/market-dashboard/components/advertiser-list/advertiser-list.component';
import { PlannerDashboardComponent } from './components/planner-dashboard/planner-dashboard.component';
import { PerformanceForecastComponent } from './components/planner-dashboard/components/performance-forecast/performance-forecast.component';
import { InventoryAllocationComponent } from './components/planner-dashboard/components/inventory-allocation/inventory-allocation.component';
import { IoPreviewComponent } from './components/planner-dashboard/components/io-preview/io-preview.component';

//Plan workflow page components
import { PlannerEditComponent } from './components/planner-edit/planner-edit.component';
import { DigitalVideoFormatSettingsComponent } from './components/planner-edit/components/digital-video-format-settings/digital-video-format-settings.component'
import { TargetingComponent } from './components/planner-edit/components/targeting/targeting.component';
import { BuyDemoComponent } from './components/lib/buy-demo/buy-demo.component';
import { FlightScheduleComponent } from './components/lib/flight-schedule/flight-schedule.component';
import { PlanSettingsComponent } from './components/planner-edit/components/plan-settings/plan-settings.component';
import { FooterComponent } from './components/footer/footer.component';
import { InventorysourceComponent } from './components/lib/inventorysource/inventorysource.component';
import { AudienceTargetingComponent } from './components/lib/audience-targeting/audience-targeting.component';
import { GeoTargetingComponent } from './components/lib/geo-targeting/geo-targeting.component';
import { BudgetFlightScheduleComponent } from './components/lib/budget-flight-schedule/budget-flight-schedule.component';
import { FormTitleComponent } from './components/lib/form-title/form-title.component';
import { FrequencyCapComponent } from './components/lib/frequency-cap/frequency-cap.component';
import { CrossDeviceComponent } from './components/lib/crossdevice/crossdevice.component';
import { FormSideNavBarComponent } from './components/lib/form-side-nav-bar/form-side-nav-bar.component';
import { MarketSiteListComponent } from './components/lib/market-site-list/market-site-list.component';
import { MarketAppListComponent } from './components/lib/market-app-list/market-app-list.component';
import { GoalsComponent } from './components/lib/goals/goals.component';
import { PrivateDealsComponent } from './components/lib/private-deals/private-deals.component';
import { PgDealComponent } from './components/lib/pg-deal/pg-deal.component';
import { AmobeePreferredDealsComponent } from './components/lib/amobee-preferred-deals/amobee-preferred-deals.component';
import { PlanConfirmationComponent } from './components/planner-edit/components/plan-confirmation/plan-confirmation.component';
import { BudgetingService } from './services/budgeting.service';
import { TimezonePipe } from '../common/pipes/timezone.pipe';
import { LabelsComponent } from './components/lib/labels/labels.component';
import { AdsTxtStatusComponent } from './components/lib/ads-txt-status/ads-txt-status.component';
import { DevicesComponent } from './components/lib/devices/devices.component';
import { PlayerSizeComponent } from './components/lib/player-size/player-size.component';
import { AdVisibilityComponent } from './components/lib/ad-visibility/ad-visibility.component';
import { NielsenDemoComponent } from './components/lib/nielsen-demo/nielsen-demo.component';
import { BrandSafetyComponent } from './components/lib/brand-safety/brand-safety.component';
import { ContextualComponent } from './components/lib/contextual/contextual.component';
import { PageQualityComponent } from './components/lib/page-quality/page-quality.component';
import { DaypartTargetingComponent } from './components/lib/daypart-targeting/daypart-targeting.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InventoryFilterService } from './services/inventory-filter.service';
import { InventoryManagementComponent } from './components/planner-edit/components/inventory-management/inventory-management.component';
import { BidPriceComponent } from './components/lib/bid-price/bid-price.component';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { ThirdPartyCostComponent } from './components/lib/third-party-cost/third-party-cost.component';
import { AdvancedBudgetAllocationComponent } from './components/lib/advanced-budget-allocation/advanced-budget-allocation.component';

const Components = [
  PlannerEditComponent,
  DigitalVideoFormatSettingsComponent,
  TargetingComponent,
  FooterComponent,
  AdvertiserDashboardComponent,
  PlannerListComponent,
  MarketDashboardComponent,
  AdvertiserListComponent,
  PlannerDashboardComponent,
  InventorysourceComponent,
  AudienceTargetingComponent,
  GeoTargetingComponent,
  BudgetFlightScheduleComponent,
  BuyDemoComponent,
  FlightScheduleComponent,
  PlanSettingsComponent,
  FormTitleComponent,
  FrequencyCapComponent,
  CrossDeviceComponent,
  FormSideNavBarComponent,
  MarketSiteListComponent,
  MarketAppListComponent,
  AdsTxtStatusComponent,
  DevicesComponent,
  PlayerSizeComponent,
  AdVisibilityComponent,
  GoalsComponent,
  PrivateDealsComponent,
  PgDealComponent,
  AmobeePreferredDealsComponent,
  PlanConfirmationComponent,
  PerformanceForecastComponent,
  InventoryAllocationComponent,
  IoPreviewComponent,
  LabelsComponent,
  NielsenDemoComponent,
  DaypartTargetingComponent,
  InventoryManagementComponent,
  BidPriceComponent,
  PageQualityComponent,
  ContextualComponent,
  BrandSafetyComponent,
  DealListComponent,
  ThirdPartyCostComponent,
  ForecastBlueprintComponent,
  AdvancedBudgetAllocationComponent
]

@NgModule({
  declarations: [
    ...Components
  ],

  imports: [
    CommonModule,
    PlannerRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AppCommonModule,
    HttpClientModule,
    NgbModule,
    DragDropModule,
    ChartsModule
  ],
  providers: [
    ListActionsService,
    BudgetingService,
    InventoryFilterService,
    DataService,
    TimezonePipe,
    PercentPipe,
    DecimalPipe,
    CurrencyPipe,
    ThemeService
  ],
  schemas: [
    NO_ERRORS_SCHEMA,
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class PlannerModule { }
